<div class="ph-drop">
  <div #phDropTarget>
    <ng-content select=".target"></ng-content>
  </div>
  <div #phDropContent class="ph-drop__content">
    <ng-content select=".content"></ng-content>
  </div>
</div>
